import { buildCollection } from "@firecms/core";

export const winConditionCollection = buildCollection({
  name: "Win Condition",
  id: "win_condition",
  path: "win_condition",
  icon: "workspace_premium",
  group: "Win Condition",
  textSearchEnabled: true,
  properties: {
    name: {
      name: "Name",
      dataType: "string",
      validation: {
        required: true,
      },
    },
    matrix: {
      name: "Matrix",
      dataType: "map",
      properties: {
        a: {
          name: "A",
          dataType: "boolean",
          defaultValue: false,
        },
        b: {
          name: "B",
          dataType: "boolean",
          defaultValue: false,
        },
        c: {
          name: "C",
          dataType: "boolean",
          defaultValue: false,
        },
        d: {
          name: "D",
          dataType: "boolean",
          defaultValue: false,
        },
        e: {
          name: "E",
          dataType: "boolean",
          defaultValue: false,
        },
        f: {
          name: "F",
          dataType: "boolean",
          defaultValue: false,
        },
        g: {
          name: "G",
          dataType: "boolean",
          defaultValue: false,
        },
        h: {
          name: "H",
          dataType: "boolean",
          defaultValue: false,
        },
        i: {
          name: "I",
          dataType: "boolean",
          defaultValue: false,
        },
        j: {
          name: "J",
          dataType: "boolean",
          defaultValue: false,
        },
        k: {
          name: "K",
          dataType: "boolean",
          defaultValue: false,
        },
        l: {
          name: "L",
          dataType: "boolean",
          defaultValue: false,
        },
        m: {
          name: "M",
          dataType: "boolean",
          defaultValue: false,
        },
        n: {
          name: "N",
          dataType: "boolean",
          defaultValue: false,
        },
        o: {
          name: "O",
          dataType: "boolean",
          defaultValue: false,
        },
        p: {
          name: "P",
          dataType: "boolean",
          defaultValue: false,
        },
        q: {
          name: "Q",
          dataType: "boolean",
          defaultValue: false,
        },
        r: {
          name: "R",
          dataType: "boolean",
          defaultValue: false,
        },
        s: {
          name: "S",
          dataType: "boolean",
          defaultValue: false,
        },
        t: {
          name: "T",
          dataType: "boolean",
          defaultValue: false,
        },
        u: {
          name: "U",
          dataType: "boolean",
          defaultValue: false,
        },
        v: {
          name: "V",
          dataType: "boolean",
          defaultValue: false,
        },
        w: {
          name: "W",
          dataType: "boolean",
          defaultValue: false,
        },
        x: {
          name: "X",
          dataType: "boolean",
          defaultValue: false,
        },
        y: {
          name: "Y",
          dataType: "boolean",
          defaultValue: false,
        },
      },
    },
    sort_index: {
      name: "Sort Index",
      dataType: "number",
      validation: {
        integer: true,
        positive: true,
      },
    },
  },
});
